var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.334 8a6.667 6.667 0 016.667-6.667v0A6.667 6.667 0 0114.667 8v0a6.667 6.667 0 01-6.666 6.667v0A6.667 6.667 0 011.334 8v0z",
    stroke: "#262A33",
    strokeOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 3.5v5H12v-1H8.5v-4h-1z",
    fill: "#262A33",
    fillOpacity: 0.5
  })));
}
export default __webpack_public_path__ + "static/time_icon.6c50d18b.svg";
export { SvgTimeIcon as ReactComponent };